<template>
    <div class="fixed-button">
      <v-tooltip :top="floatBtn.top" :bottom="floatBtn.bottom" :right="floatBtn.right" :left="floatBtn.left">
        <template v-slot:activator="{ on, attrs }">
          <v-btn style="pointer-events: all;" v-bind="attrs" v-on="on" :disabled="floatBtn.disabled" v-model="floatBtn.show" @click="$emit('click-float-btn')" fab dark color="var(--v-primary-base)">
            <v-icon v-if="floatBtn.icon">{{floatBtn.icon}}</v-icon>
            <img v-if="floatBtn.iconSVG" :src="floatBtn.iconSVG" onload="SVGInject(this)" width="20" height="20"/>
          </v-btn>
        </template>
        <span>{{ floatBtn.title }}</span>
      </v-tooltip>
    </div>
</template>

<script>
export default {

    /** @param example
        floatBtn = {
          show: false,
          top: false,
          bottom: false,
          right: false,
          left: false,
          color: var(--v-primary-base),
          icon: -> icon baseado no mdi icons, exemplo 'mdi-domain',
          title: string,
          disabled: false
        }

        Para utilizar, basta chamar no html <base-float-button :floatBtn="floatBtn" @click-float-btn="handleClick" width="50" height="50"/>
        em que precisa passar as props para o floatBtn
    */

    props: {
        inheritAttrs: false,
        floatBtn: {
            show: Boolean,
            top: Boolean,
            bottom: Boolean,
            right: Boolean,
            left: Boolean,
            color: String,
            icon: String,
            disabled: { type: Boolean, require: false, default: false },
            title: String
        },
    }
}
</script>
<style lang="scss" scoped>
    .fixed-button {
      position: sticky;
      bottom: 40px;
      right: 20px;
      z-index: 9999;
      justify-content: flex-end;
      display: flex;
      pointer-events: none;
    }

    .theme--dark.v-btn.v-btn--disabled.v-btn--has-bg {
      background-color: rgba(0,0,0,.12)!important;

      /* ::v-deep svg {
        g {
          fill: rgba(0,0,0,.26)!important;
        }
        rect {
          fill: rgba(0,0,0,.26)!important;
        }
      } */
    }
</style>
